import React, { useState } from "react";
import { FullCalendarPage as FullCalendarPageInner } from "./index";
import BlockoutFormModal from "./BlockoutFormModal";
import BlockoutManagerPanel from "./BlockoutManagerPanel";

// ============================================================
// FullCalendarPage (route wrapper) — owns the New-Blockout modal state
// and forwards its `onNewBlockout` callback (now accepts a Date) to the
// inner calendar's Add-Chooser. Also renders BlockoutManagerPanel.
// Route: /check-ins/calendar.
// ============================================================
export default function FullCalendarPageRoute({
  currentUser, isSuperAdmin, isLimitedAdmin, events, services, appointments,
  blockouts, setBlockouts, users, members, tasks, setTasks,
  persist, addAudit, addNotification, navigate,
}) {
  const [showBlockoutForm, setShowBlockoutForm] = useState(false);
  const [editingBlockout, setEditingBlockout] = useState(null);
  const [prefillDate, setPrefillDate] = useState(null);
  return (
    <>
      <FullCalendarPageInner
        currentUser={currentUser}
        isSuperAdmin={isSuperAdmin}
        isLimitedAdmin={isLimitedAdmin}
        events={events}
        services={services}
        appointments={appointments}
        blockouts={blockouts}
        members={members}
        tasks={tasks}
        setTasks={setTasks}
        navigate={navigate}
        onNewBlockout={(d) => { setEditingBlockout(null); setPrefillDate(d || null); setShowBlockoutForm(true); }}
      />
      <BlockoutManagerPanel
        currentUser={currentUser}
        isSuperAdmin={isSuperAdmin}
        isLimitedAdmin={isLimitedAdmin}
        blockouts={blockouts}
        setBlockouts={setBlockouts}
        users={users}
        onEdit={(b) => { setEditingBlockout(b); setShowBlockoutForm(true); }}
      />
      {showBlockoutForm && (
        <BlockoutFormModal
          currentUser={currentUser}
          users={users}
          blockouts={blockouts}
          setBlockouts={setBlockouts}
          persist={persist}
          addAudit={addAudit}
          addNotification={addNotification}
          existing={editingBlockout}
          prefillDate={prefillDate}
          onClose={() => { setShowBlockoutForm(false); setEditingBlockout(null); setPrefillDate(null); }}
          onSaved={() => { setShowBlockoutForm(false); setEditingBlockout(null); setPrefillDate(null); }}
        />
      )}
    </>
  );
}
